// extracted by mini-css-extract-plugin
export default {"referenceWrapper":"referenceWrapper--vGCKI","wrapper":"wrapper--_x3Dl"};